module.exports = __webpack_public_path__ + "static/img/icon_group.e2a0481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/icon_group.png
// module id = 7VMI
// module chunks = 0